import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import WarningTriangle from '../../../../public/assets/img/warning.svg';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { TextField, CardContent, Card, styled, Grid, InputAdornment } from '@mui/material';
import { CircularProgressLoader } from '../../../shared/components/Loaders';
import { useDispatch, useSelector } from 'react-redux';
import { locationActivationComplete, storeLocation } from '../../../redux/saga/checkmateAuthorizationSelector';
import sevenNowLogo from '../../../../public/assets/img/seven-now-logo.svg';
import CustomPopOver from '../../../shared/pop-over/custom.pop-over';
import { LOGIN_VERBIAGE, OTP_VERBIAGE, EMAIL_VERBIAGE, LOCATION_LIST, DELIVERY_TIME, LAUNCH_TIME, IMAGES, INITIAL_MODEL_CONTENT, LIST_OF_ACCOUNT_CREATION, LOCATION_MODEL_CONTENT, REDIRECT_CONNECT_POPOVER, RESTRICT_MODEL } from '../../../constants/landingConstant';
import { forgotPasswordCall } from '../../../api/api';
import { getIacmLocationCall, getIacmActivateLocationCall, getClearResponse } from '../../../redux/actions/checkmateAuthorizationAction';
import { getAuthUser, setUserNameAction } from '../../../redux/actions/amazonWebServicesAction';
import { activateLocationRes } from '../../../redux/saga/checkmateAuthorizationSelector';
import {
  BACK_TO_LOGIN,
  CONNECT,
  FORGOT_PASSWORD,
  PRIVACY_POLICY_CONTENT,
  LOG_IN,
  SEND_EMAIL,
  USERNAME_EMAIL_REQUIRED,
  PASSWORD_REQUIRED,
  MINI_CHAR,
  PASS_MINI_CHAR,
  MERCHANT_PORTAL_TEXT,
} from '../../../constants/buttonConstants';
import './login.scss';
import { setInitialRoute, updateAppOrgName } from '../../../redux/actions/merchantAction';
import { encryptPassword } from '../../../shared/utils/common';
import { accessTokenSaga, loginResponseSaga } from '../../../redux/saga/loginServiceSelector';
import { authenticateUserRequest } from '../../../redux/actions/loginServiceAction';
import { restrictOnlyFewSpecialChara, validateUserNameandEmail } from '../../../shared/utils/format.helpers';
import { LOGIN_FAILED_ERROR, LOGIN_FAILED_TIMEOUT } from '../../../constants/merchantsConstants';

const CssTextField = styled(TextField)({
    '& label.Mui-focused': {
        color: '#111111',
        fontWeight: '700'
    },
});

const buttonStyle = {
  backgroundColor: '#E6F1EE',
  borderRadius: '20px',
  borderColor: 'transparent',
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: '700',
  height: '40px',
  width: '100%',
  color: '#00563C',
};

const LoginIACM = ({ orgName }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [userNameCard, setUserNameCard] = useState(false);
	const [userName, setUserName] = useState('');
	const [password, setPassword] = useState('');
	const [userNameError, setUserNameError] = useState(false);
	const [passwordError, setPasswordError] = useState(false);
	const [loginErrorMsg, setloginErrorMsg] = useState('');
	const [cardForOtp, setCardForOtp] = useState(false);
	const [loading, setLoading] = useState(true);
	const [popOverTitle, setpopOverTitle] = useState();
	const [merchantAccountView, setmerchantAccountView] = useState();
	const [listData, setlistData] = useState(null);
	const [listTitle, setlistTitle] = useState('');
	const [listControl, setlistControl] = useState('');
	const [primaryButtonText, setprimaryButtonText] = useState('');
	const [open, setOpen] = useState(false);
	const [selectedValue, setSelectedValue] = useState('');
	const [showLowerDescription, setshowLowerDescription] = useState('');
	const [listHeight, setListHeight] = useState('100px');
	const storeLocationData = useSelector(storeLocation);
	const [apiInProgress, setapiInProgress] = useState(false);
	const [formValid, setformValid] = useState(false);
	const [emailWord, setEmailWord] = React.useState('');
	const [userNameErrorMsg, setUserNameErrorMsg] = useState('');
	const [passwordErrorMsg, setPasswordErrorMsg] = useState('');
	const { state } = useLocation();
	const activateLocationResult = useSelector(activateLocationRes);
	const locationActivationCompleteResult = useSelector(locationActivationComplete);
	const loginResponseData = useSelector(loginResponseSaga);
	const accessTokenValue = useSelector(accessTokenSaga);
	const [queryParameters] = useSearchParams();

	const reqEmail = process.env.REQUEST_ACCESS_MAIL;

	const validateUserNameandEmail = (userinput) => {
		let exp = /^[A-Za-z0-9!#@%*.:_^-]*$/;
		return userinput.split(' ').length === 1 && exp.test(userinput);
	};

	const restrictOnlyFewSpecialChara = (val) => {
		let exp = /^[a-zA-Z0-9!#@%*:_^-]+$/;
		return exp.test(val);
	};

	useEffect(() => {
		let emailWordText = EMAIL_VERBIAGE;
		emailWordText = emailWordText.replace('[email]', reqEmail);
		setEmailWord(emailWordText);
		if (state?.['code'] || queryParameters.get('code')) {
		sessionStorage.setItem('code', state?.['code'] || queryParameters.get('code'));
		navigate('/iacm');
		}
		sessionStorage.setItem('orgName', 'IACM');
		dispatch(updateAppOrgName('IACM'));
	}, []);

	useEffect(()=>{
		if(userNameCard){
			setformValid(userName !== '' && validateUserNameandEmail(userName));
		} else {
			setformValid(userName !== '' && validateUserNameandEmail(userName) && password !== '' && restrictOnlyFewSpecialChara(password));
		}
	},[userName, password]);

	useEffect(() => {
		if (loginResponseData) {
			if (loginResponseData?.idToken) {
				setUserNameError(false);
				setPasswordError(false);
				setUserNameErrorMsg('');
				setPasswordErrorMsg('');
				if (loginResponseData?.isAdmin) {
					dispatch(getAuthUser(true));
					dispatch(setInitialRoute(''));
					sessionStorage.setItem('isAdmin', true);
					navigate('/dashboard/adminhomepage');
				} else {
					sessionStorage.setItem('isAdmin', false);
					dispatch(updateAppOrgName('IACM'));
					dispatch(setInitialRoute('iacm'));
					dispatch(getAuthUser(true));
				
					if (!locationActivationCompleteResult && sessionStorage.getItem('code')) {
						const codeVal = sessionStorage.getItem('code');
						if (codeVal) {
							const codeToken = {
								code: codeVal,
							};
							dispatch(getIacmLocationCall(codeToken));
						}
					} else {
						sessionStorage.setItem('merchantAuth', 'false');
						setapiInProgress(false);
						dispatch(getAuthUser(false));
					}
				} 
			}
			else {
				setapiInProgress(false);
				// console.log('DD ',loginResponseData.details, loginResponseData.details?.data?.message);
				if (loginResponseData?.details?.data?.message) {
				setUserNameError(true);
				setPasswordError(true);
				setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
				setPasswordErrorMsg(PASSWORD_REQUIRED);
				setloginErrorMsg(String(loginResponseData?.details?.data?.message));
				} else if (loginResponseData?.details?.code === 'ECONNABORTED') {
				setUserNameError(true);
				setPasswordError(true);
				setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
				setPasswordErrorMsg(PASSWORD_REQUIRED);
				setloginErrorMsg(LOGIN_FAILED_TIMEOUT);
				} else {
				setUserNameError(true);
				setPasswordError(true);
				setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
				setPasswordErrorMsg(PASSWORD_REQUIRED);
				setloginErrorMsg(LOGIN_FAILED_ERROR);
				}
			}
		}
	}, [loginResponseData]);

	useEffect(() => {
		// console.log('STORE LOCATION DATA ',storeLocationData)
		if (storeLocationData && storeLocationData.id) {
		setapiInProgress(false);
		showLocationOptionsPopOver();
		} else {
		if (typeof storeLocationData === 'string') {
			setloginErrorMsg(storeLocationData);
		} else if (storeLocationData && storeLocationData.msg) {
			sessionStorage.setItem('code', '');
			dispatch(getAuthUser(true));
			setapiInProgress(false);
			navigate('/integration_failed');
		}
		}
	}, [storeLocationData]);

	useEffect(() => {
		if (activateLocationResult && activateLocationResult.message) {
		sessionStorage.setItem('code', '');
		dispatch(getAuthUser(true));
		setapiInProgress(false);
		navigate('/integration_success');
		} else if (activateLocationResult && activateLocationResult.msg) {
		sessionStorage.setItem('code', '');
		dispatch(getAuthUser(true));
		setapiInProgress(false);
		navigate('/integration_failed');
		}
	}, [activateLocationResult]);

  
	const handleLogin = (e) => {
		e.preventDefault();
		setUserNameError(false);
		setPasswordError(false);
		setUserNameErrorMsg('');
		setPasswordErrorMsg('');
		setloginErrorMsg('');
		dispatch(getClearResponse({}));
		validation()
		.then(
			(res) => {
			if (res.userName === '' && res.password === '' && formValid) {
				setapiInProgress(true);
				const encryptedPassword = encryptPassword(password);
				dispatch(authenticateUserRequest(userName, encryptedPassword));
			}
			},
			(err) => {
			setapiInProgress(false);
			console.log(err);
			}
		)
		.catch((err) => {
			setapiInProgress(false);
			console.log(err);
		});
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		if (userNameCard && userName !== '') {
		forgotPasswordCall(userName)
			.then(
			(data) => {
				setCardForOtp(true);
				dispatch(setUserNameAction(userName));
				navigate('/checkemail');
			},
			(err) => {
				console.log(err);
			}
			)
			.catch((err) => console.log(err));
		} else {
		handleLogin(event);
		}
	};

	const validation = () => {
		return new Promise((resolve, reject) => {
		if (userName === '' && password === '') {
			setUserNameError(USERNAME_EMAIL_REQUIRED);
			setPasswordError(PASSWORD_REQUIRED);
			setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
			setPasswordErrorMsg(PASSWORD_REQUIRED);
			resolve({ userName: USERNAME_EMAIL_REQUIRED, password: PASSWORD_REQUIRED});
		} else if (userName === '') {
			setUserNameError(USERNAME_EMAIL_REQUIRED);
			setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
			resolve({ userName: USERNAME_EMAIL_REQUIRED, password: '' });
		} else if (password === '') {
			setPasswordError(PASSWORD_REQUIRED);
			setPasswordErrorMsg(PASSWORD_REQUIRED);
			resolve({ userName: '', password: PASSWORD_REQUIRED });
		} else if (password.length < 6) {
			setPasswordError(MINI_CHAR);
			setPasswordErrorMsg(PASS_MINI_CHAR);
			resolve({ userName: '', password: PASS_MINI_CHAR });
		} else {
			setUserNameError(false);
			setPasswordError(false);
			setUserNameErrorMsg('');
			setPasswordErrorMsg('');
			resolve({ userName: '', password: '' });
		}
		});
	};

	const showLocationOptionsPopOver = () => {
		setprimaryButtonText(CONNECT);
		setlistTitle(LOCATION_MODEL_CONTENT.TITLE_ONE);
		setpopOverTitle(<p className='heading-block'>{LOCATION_MODEL_CONTENT.TITLE}</p>);
		setmerchantAccountView(
		<Grid container>
			<Grid item>{LOCATION_MODEL_CONTENT.CLAUSE_ONE}</Grid>
			<br />
			<Grid item>{LOCATION_MODEL_CONTENT.CLAUSE_TWO}</Grid>
		</Grid>
		);
		setOpen(true);
		setlistTitle('7NOW Merchant Locations');
		setlistControl('Radio');
		setlistData([
		{
			label: storeLocationData.name,
			subLabel: `${storeLocationData.address}, ${storeLocationData.city}, ${storeLocationData.state} ${storeLocationData.zipcode}`,
			disabled: false,
		},
		]);
		setshowLowerDescription(
		<Grid container>
			<Grid item>
			<div className='list-block'>
				<h5 style={{ color: '#00563C' }}>
				<u>ItsaCheckmate Location</u>
				</h5>
				<br />
				<p>ID: {storeLocationData.id}</p>
				<p>Name: {storeLocationData.name}</p>
				<p>
				Address: {storeLocationData.address}, {storeLocationData.city}, {storeLocationData.state} {storeLocationData.zipcode}
				</p>
				<p>POS: {storeLocationData.pos}</p>
			</div>
			</Grid>
		</Grid>
		);
	};

	const reguestAccessHandler = (e) => {
		const reqText = process.env.REQUEST_ACCESS_MAIL;
		const mailto = `mailto:${reqText}`;
		window.location.href = mailto; //'mailto:no-reply@checkmate.com';
		e.preventDefault();
	};

	const termsOfUseHandler = (e) => {
		window.open(process.env.TERMS_URL, '_blank');
		e.preventDefault();
	};

	const privacyPolicyHandler = (e) => {
		window.open(process.env.PRIVACY_URL, '_blank');
		e.preventDefault();
	};

	const handleClose = (value) => {
		setOpen(false);
		sessionStorage.setItem('IndicatorPopOverShown', 'true');
		setSelectedValue(value);
		if (value && value.length === 0 && Object.keys(storeLocationData).length > 0) {
		showLocationOptionsPopOver();
		} else if (value && value.length > 0 && Object.keys(storeLocationData).length > 0) {
		setapiInProgress(true);
		if (accessTokenValue) {
			const codeId = {
			storeLocationId: storeLocationData.id,
			accessToken:accessTokenValue
			};
			dispatch(getIacmActivateLocationCall(codeId));
		}
		}
	};

	const showRestrictionPopup = () => {
		let emailWordText = RESTRICT_MODEL.CLAUSE_TWO;
		emailWordText = emailWordText.replace('[email pending]', process.env.REQUEST_ACCESS_MAIL);
		//console.log('EMAIL TEXT ', emailWordText)
		setprimaryButtonText('');
		setSelectedValue([]);
		setpopOverTitle(
		<Grid container spacing={1}>
			<Grid item>
			<p className='heading-block'>{RESTRICT_MODEL.HEADER_LEFT}</p>
			</Grid>
			<Grid item xs={6} md={6}>
			<p className='heading-grey'>{RESTRICT_MODEL.HEADER_RIGHT}</p>
			</Grid>
		</Grid>
		);
		setmerchantAccountView(
		<Grid container>
			<Grid item>
			<p>{RESTRICT_MODEL.CLAUSE_ONE}</p>
			</Grid>
			<Grid item>
			<p>{emailWordText}</p>
			</Grid>

			<Grid item>
			<p style={{ marginBottom: '0' }}>{RESTRICT_MODEL.CLAUSE_THREE}</p>
			</Grid>
		</Grid>
		);
		setlistData(null);
		setOpen(true);
	};

	const userAccountList = (landingStyle) => {
		return (
		<div className={landingStyle ? 'content-leftPanel' : ''}>
			{landingStyle ? (
			<>
				<p>{LOGIN_VERBIAGE}</p>
				<p className='no-bottom-margin'>{emailWord}</p>
			</>
			) : (
			''
			)}
			<li>{LOCATION_LIST}</li>
			<li>{DELIVERY_TIME}</li>
			<li>{LAUNCH_TIME}</li>
			<li>{IMAGES}</li>
		</div>
		);
	};

	const card = (
		<CardContent className='login-card'>
		<form className='display-grid' autoComplete='off' onSubmit={handleSubmit}>
			{userNameCard ? (
			<>
				<p className='p-class'> {FORGOT_PASSWORD}</p>
				<br />
				<CssTextField
				id='custom-css-outlined-input0'
				label='Username / Email'
				onChange={(e) => setUserName(e.target.value)}
				variant='outlined'
				color='secondary'
				aria-label='UserName'
				type='text'
				sx={{ mb: 3 }}
				fullWidth
				value={userName}
				error={!!userNameError}
				data-testid='username-input'
				helperText={userNameErrorMsg}
				/>
			</>
			) : (
			<>
				<p className='p-class'> {LOG_IN}</p>
				<br />
				<CssTextField
				id='custom-css-outlined-input1'
				label='Username / Email'
				onChange={(e) => setUserName(e.target.value)}
				variant='outlined'
				color='secondary'
				type='text'
				//aria-label='Username / Email'
				sx={{ mb: 3 }}
				fullWidth
				value={userName}
				error={!!userNameError}
				helperText={userNameErrorMsg}
				data-testid='username-input'
				InputProps={{
					endAdornment: <InputAdornment position='end'>{userNameError ? <img src={WarningTriangle} className='error-icon' /> : null}</InputAdornment>,
				}}
				/>
				<CssTextField
				id='custom-css-outlined-input2'
				label='Password'
				onChange={(e) => setPassword(e.target.value)}
				variant='outlined'
				color='secondary'
				type='password'
				//aria-label='Password'
				value={password}
				error={!!passwordError}
				helperText={passwordErrorMsg}
				data-testid='password-input'
				autoComplete='on'
				fullWidth
				sx={{ mb: 3 }}
				InputProps={{
					endAdornment: <InputAdornment position='end'>{passwordError ? <img src={WarningTriangle} className='error-icon' /> : null}</InputAdornment>,
				}}
				
				/>
				<br />
				<br />
				<p className='warning-msg' data-testid='incorrect-logins' >{loginErrorMsg}</p>
				<br/>
				<p className='login-terms marginbottom24'> {PRIVACY_POLICY_CONTENT.AGREE} <b className='termsandpolicy' onClick={privacyPolicyHandler} >{PRIVACY_POLICY_CONTENT.PRIVACY_POLICY_LABEL}</b> {PRIVACY_POLICY_CONTENT.AND} <b className='termsandpolicy' onClick={termsOfUseHandler}>{PRIVACY_POLICY_CONTENT.TERMS_OF_USE_LABEL}</b></p>
			</>
			)} 
			<button className='submit-button-class' variant='outlined' type='submit' data-testid='login-button'>
			{!userNameCard ? LOG_IN : SEND_EMAIL}
			</button>

			{!userNameCard ? (
			<>
				<br />
				<button className='submit-button-class-secondary' variant='outlined' onClick={reguestAccessHandler} type='button'>
				Request Access
				</button>
				
			</>
			) : (
			<>
				<br />
				<button variant='outlined' type='button' className='form-container--secondaryButton' onClick={() => setUserNameCard(false)}>
				{BACK_TO_LOGIN}
				</button>

				<br />
				<p>{OTP_VERBIAGE}</p>
			</>
			)}
		</form>
		</CardContent>
	);

	return (
		<>
			<Container fluid data-testid='LoginIACM-id' className='vh-100 d-flex flex-column '>
				<Row className='h-100'>
				<Col className='background-white-class'>
					<Row className='margin_Panel'></Row>
					<Row>
					<Col xs={14}>
						<div className='landing-logo-holder aligncenter'>
						<img src={sevenNowLogo} className='img-right-align' alt='SevenNow header Logo' />
						<h2 className='merchant-title1'> {MERCHANT_PORTAL_TEXT}</h2>
						</div>
						{userAccountList(true)}
					</Col>
					</Row>
				</Col>
				<Col className='cont-background'>
					<Row className='margin_Panel'></Row>
					<Row>
					<Col xs={2}></Col>
					<Col xs={8}>
						<Card variant='outlined' className='cont-min-class2'>
						{card}
						</Card>
					</Col>
					<Col xs={2}></Col>
					</Row>
				</Col>
				</Row>
			</Container>

			<CustomPopOver
				title={popOverTitle}
				descriptionContent={merchantAccountView}
				selectedValue={selectedValue}
				open={open}
				listHeight={listHeight}
				showLowerDescription={showLowerDescription}
				listTitle={listTitle}
				listData={listData}
				listControl={listControl}
				listSelectAll={true}
				primaryButton={primaryButtonText}
				onClose={handleClose}
			/>

			{apiInProgress === true ? (
				<div className='loader-style'>
				<CircularProgressLoader />
				</div>
			) : null}
		</>
	);
};

export default LoginIACM;
